<template>
  <div id="training_infors_outer">
    <training-view v-for="(item, index) in trainingList"
    :key="item.uuid"
    :item="item"
    :index="index"
    :noticed="showRedBorder"
    v-on:deleteItem="deleteTrainingItem"
     />

    <div style="margin-top: 30px;" ><a href="javascript:void(0)" @click="addNewTrainingItem">+添加更多经历</a></div>

    <div style="width: 100%;text-align: center;margin-top: 50px;">
      <el-button class="bottom-button back-button" @click="backButtonClicked" round>上一步</el-button>
      <el-button v-if="isAllField" class="bottom-button next-button" round @click="nextButtonClicked"> 下一步</el-button>
      <el-button v-else  class="bottom-button gray-button" round @click="noticeButtonClicked"> 下一步</el-button>
    </div>
  </div>
</template>

<script>
  import TrainingCardItem from "../cards/TrainingCardItem.vue";
  import DataCreator from "../../../../js/coach/data-creator.js";
  import EventManager from "../../../../js/event-common.js";
  import {Loading} from "element-ui";
  export default {
    name: "AddTrainingsInformationVue",
    props: {
      coachItem: {
        type: Object,
        default: null,
      }
    },
    components: {
      TrainingView: TrainingCardItem,
    },
    data() {
      return {
        trainingList: [],
        initialList: [],
        isAllField: false,
        isEdited: false,
        showRedBorder: false,
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      httpManager() {
        return this.$store.state.http;
      },
      eventManager() {
        return this.$store.state.eventManager;
      },
    },

    watch: {
      trainingList: {
        handler(val, oldVal) {
          this.isAllField = this.isDataAllFilled();
          console.log(this.isAllField);
          console.log(val);
          this.isDataEidted();
        },
        deep: true
      },
    },
    mounted() {
      this.initData();
    },
    methods:{
      initData() {
        let cultivates = this.coachItem.cultivates;
        if (cultivates == null || cultivates.length == 0) {
          let resumeData = DataCreator.methods.cultivate.getEmptyItem();
          resumeData.coachId = this.coachItem.coach.id;
          let model = DataCreator.methods.cultivate.getModelFromItem(resumeData);
          this.trainingList.push(model);
          let copiedModel = DataCreator.tools.deepCopy(model);
          this.initialList.push(copiedModel);
        } else {
          for (let i = 0; i < cultivates.length; i++) {
            let item = cultivates[i];
            let model = DataCreator.methods.cultivate.getModelFromItem(item);
            this.trainingList.push(model);
            let copiedModel = DataCreator.tools.deepCopy(model);
            this.initialList.push(copiedModel);
          }
        }
      },

      isDataAllFilled() {
        let trainingList = this.trainingList;
        let allFilled = true;
        for (let i = 0; i < trainingList.length; i++) {
          let item = trainingList[i];
          let isFilled = DataCreator.tools.isItemAllFilled(item);
          if (!isFilled) {
            allFilled = false;
            break;
          }
        }
        return allFilled;
      },

      isDataEidted() {
        let isEdited = !DataCreator.tools.isDeepEqualed(this.trainingList, this.initialList);
        if (this.isEdited == isEdited) {
          return;
        }
        this.isEdited = isEdited;
        let allowedLeave = !this.$store.state.allowedLeave;
        if (allowedLeave != isEdited) {
          this.$store.commit('isAllowedLeave', !isEdited);
        }
        console.log('数据是否改变：' + this.isEdited);
      },



      deleteTrainingItem(res) {
        console.log(res);
        let index = res.index;
        this.trainingList.splice(index, 1)
      },

      addNewTrainingItem() {
        let emptyData = DataCreator.methods.cultivate.getEmptyItem();
        emptyData.coachId = this.coachItem.coach.id;
        let model = DataCreator.methods.cultivate.getModelFromItem(emptyData);
        this.trainingList.push(model);
      },

      updateStatus(status, success, failure) {
        let params = {};
        let coachItem = this.coachItem;
        params.status = status;
        params.auditStatus = 1;
        params.id = coachItem.coach.id;
        this.httpManager.ajax.postCoachStatusUpdateRequest(params, function(data) {
          console.log(data);
          console.log('upate coach status succeed!');
          let code = data.code;
          if (code == 0) {
            success();
            return;
          }
          failure(data);
        }, function(data) {
          failure(data);
        });
      },

      backButtonClicked() {
        if (this.isEdited) {
          let _this = this;
          this.$confirm('当前页面已经修改，是否放弃修改？', '提示', {
            confirmButtonText: '放弃',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            _this.$store.commit('isAllowedLeave', true);
            _this.$emit('back');
          }).catch(() => {
            //...
          })
        } else {
          this.$emit('back');
        }
      },

      noticeButtonClicked() {
        let trainingList = this.trainingList;
        if (trainingList == null || trainingList.length == 0) {
          return;
        }
        let unCheckedList = ['id', 'uuid', 'coachId'];
        OutLoop:
        for(let i = 0; i < trainingList.length; i++) {
          let model = trainingList[i];
          for(let key in model) {
            if (unCheckedList.indexOf(key) >= 0) {
              continue;
            }
            let value = model[key];
            let isEmpty = false;
            if (key == 'photos') {
              if (value.length == 0) {
                isEmpty = true;
              }
            } else {
              if (!value) {
                isEmpty = true;
              }
            }
            if (isEmpty) {
              let viewId = 'cultivate_' + model.uuid + '_' + key + '_view';
              // console.log(viewId);
              this.showRedBorder = true;
              document.getElementById(viewId).scrollIntoView(true);
              break OutLoop;
            }
          }
        }
      },


      nextButtonClicked() {
        if (!this.isEdited && this.trainingList[0].id > 0) { // 未修改的话，不用上传数据
          this.$emit("next");
          return;
        }

        let params = [];
        for(let i = 0; i < this.trainingList.length; i++) {
          let certItem = this.trainingList[i];
          let item = {};
          for (let key in certItem) {
            if (key == 'uuid') {
              continue;
            }
            if (key == 'photos') {
              let list = certItem[key];
              let photo = "";
              for(let j = 0; j < list.length; j++) {
                let picture = list[j];
                photo += picture.url;
                if (j < list.length - 1) {
                  photo += ",";
                }
              }
              item['photo'] = photo;
            } else {
              item[key] = certItem[key];
            }
          }
          params.push(item);
        }
        console.log(params);

        let _this = this;
        let loadFlags = Loading.service({
          target: document.getElementById('app'),
          fullscreen: true
        });
        this.httpManager.ajax.postCoachEditCultivatesRequest(params, function(data) {
           console.log('upload cultivates list success');
           console.log(data);
           let code = data.code;
           if (code == 0) {
             _this.updateStatus(4, function() {
               loadFlags.close();
               console.log('update status succeed!');
               _this.eventManager.postNotification(EventManager.notificationNameObject.updateCoachData, null);
               _this.isEdited = false;
               _this.$store.commit('isAllowedLeave', true);
             }, function(data) {
               loadFlags.close();
               console.log('update status failed!');
               _this.$toast("保存失败！");
             });
             return;
           }
           loadFlags.close();
           _this.$toast("保存失败！");
        }, function(data) {
          loadFlags.close();
          _this.$toast("保存失败，请重试！");
        });

      }
    }
  }
</script>

<style scoped>
  @import url("../../../../css/back-next-buttons.css");
  #training_infors_outer {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/children/AddTrainingsInformation.vue